
function requestAPI() {
  return fetch(`${process.env.REACT_APP_BASE_URL}category`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((res) => res.json())
}

export default function actionListCategory() {
  return async (dispatch) => {
    dispatch({
      type: 'LIST_CATEGORY_BEGIN'
    })

    try {
      const result = await requestAPI()
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'LIST_CATEGORY_SUCCESS',
        payloadMobile: result.data.slice(0, 6),
        payload: result.data.slice(0, 7),
        payloadAll: result.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'LIST_CATEGORY_FAILURE',        
    error: error    
  })
}